import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PathNames } from 'applicaiton/routes';
import PageSwitcher from 'common/components/PageSwitcher';
import { featuresPermissions } from 'common/helpers/featuresPermissions';

import WaitingAppointmentsTable from './components/WaitingAppointmentsTable';
import { Wrapper } from './styles';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const WaitingList: FC = () => {
  const { t } = useTranslation();
  const { hasAppointmentRequestPermission, hasPatientClinicalFilePermission } =
    featuresPermissions();
  const { isExpiredSoon, isBlocked } = useSubscription();

  const showSwitcher =
    hasPatientClinicalFilePermission || hasAppointmentRequestPermission;

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <div>
        {showSwitcher && (
          <PageSwitcher>
            {hasPatientClinicalFilePermission && (
              <Link to={PathNames.myPatients}>
                {t('clinicsConfiguration.aside_menu.my_patients_path')}
              </Link>
            )}
            <div>{t('clinicsConfiguration.aside_menu.waiting_list')}</div>
            {hasAppointmentRequestPermission && (
              <Link to={PathNames.requestList}>
                {t('clinicsConfiguration.aside_menu.request_list')}
              </Link>
            )}
          </PageSwitcher>
        )}
        <h1>{t('waiting_list.title')}</h1>
        <WaitingAppointmentsTable />
      </div>
    </Wrapper>
  );
};

export default WaitingList;
